/* ============================================
   BLINCE.ONLINE — Custom JavaScript
   ============================================ */

document.addEventListener('DOMContentLoaded', function() {
  
  // 1. Countdown Timer
  const initCountdown = () => {
    const countdownEl = document.querySelector('.blince-countdown');
    if (!countdownEl) return;
    
    const daysEl = document.getElementById('cd-days');
    const hoursEl = document.getElementById('cd-hours');
    const minsEl = document.getElementById('cd-mins');
    const secsEl = document.getElementById('cd-secs');
    
    if (!daysEl || !hoursEl || !minsEl || !secsEl) return;
    
    const CYCLE_MS = 2 * 24 * 60 * 60 * 1000; // 2 days in ms
    let startTime = localStorage.getItem('blince_countdown_start');
    
    if (!startTime || (Date.now() - parseInt(startTime)) > CYCLE_MS) {
      startTime = Date.now().toString();
      localStorage.setItem('blince_countdown_start', startTime);
    }
    
    const updateTimer = () => {
      const now = Date.now();
      let elapsed = now - parseInt(startTime);
      
      if (elapsed > CYCLE_MS) {
        startTime = now.toString();
        localStorage.setItem('blince_countdown_start', startTime);
        elapsed = 0;
      }
      
      const remaining = CYCLE_MS - elapsed;
      
      const d = Math.floor(remaining / (1000 * 60 * 60 * 24));
      const h = Math.floor((remaining / (1000 * 60 * 60)) % 24);
      const m = Math.floor((remaining / 1000 / 60) % 60);
      const s = Math.floor((remaining / 1000) % 60);
      
      daysEl.textContent = d.toString().padStart(2, '0');
      hoursEl.textContent = h.toString().padStart(2, '0');
      minsEl.textContent = m.toString().padStart(2, '0');
      secsEl.textContent = s.toString().padStart(2, '0');
    };
    
    updateTimer();
    setInterval(updateTimer, 1000);
  };
  
  // Newsletter popup intentionally disabled: the store does not use unsolicited popups.

  // 4. Mobile Sticky Purchase Bar
  const initStickyBar = () => {
    const stickyBar = document.querySelector('.blince-sticky-bar');
    const mainAddToCart = document.querySelector('.main-add-to-cart');
    
    if (!stickyBar || !mainAddToCart) return;
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
          stickyBar.classList.add('visible');
        } else {
          stickyBar.classList.remove('visible');
        }
      });
    }, { threshold: 0 });
    
    observer.observe(mainAddToCart);
  };
  
  // 5. FAQ Accordion
  const initFAQ = () => {
    const faqItems = document.querySelectorAll('.blince-faq-item');
    
    faqItems.forEach(item => {
      const question = item.querySelector('.blince-faq-question');
      const answer = item.querySelector('.blince-faq-answer');
      
      if (!question || !answer) return;
      
      question.addEventListener('click', () => {
        const isOpen = item.classList.contains('active');
        
        // Close all others
        faqItems.forEach(otherItem => {
          otherItem.classList.remove('active');
          const otherAnswer = otherItem.querySelector('.blince-faq-answer');
          if (otherAnswer) otherAnswer.style.maxHeight = null;
        });
        
        if (!isOpen) {
          item.classList.add('active');
          answer.style.maxHeight = answer.scrollHeight + "px";
        }
      });
    });
  };
  
  // 6. Smooth Scroll
  const initSmoothScroll = () => {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        const targetId = this.getAttribute('href');
        if (targetId === '#') return;
        
        const targetElement = document.querySelector(targetId);
        if (targetElement) {
          e.preventDefault();
          const headerOffset = 80;
          const elementPosition = targetElement.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
          });
        }
      });
    });
  };
  
  // 7. Scroll Reveal Animations
  const initScrollReveal = () => {
    // Respect prefers-reduced-motion
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) return;
    
    const revealElements = document.querySelectorAll('.blince-reveal');
    
    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      root: null,
      threshold: 0.1,
      rootMargin: "0px 0px -50px 0px"
    });
    
    revealElements.forEach(el => revealObserver.observe(el));
  };
  
  // 8. Variant Card Selector
  const initVariantSelector = () => {
    const variantCards = document.querySelectorAll('.blince-variant-card');
    const priceDisplay = document.querySelector('.main-price-display');
    const hiddenSelect = document.querySelector('.main-variant-select');
    
    if (!variantCards.length) return;
    
    variantCards.forEach(card => {
      card.addEventListener('click', () => {
        // Remove selected class from all
        variantCards.forEach(c => c.classList.remove('selected'));
        // Add to clicked
        card.classList.add('selected');
        
        // Update price if element exists
        if (priceDisplay) {
          const newPrice = card.getAttribute('data-price');
          if (newPrice) priceDisplay.innerHTML = newPrice;
        }
        
        // Update hidden select if needed for form submission
        if (hiddenSelect) {
          const variantId = card.getAttribute('data-variant-id');
          if (variantId) {
            hiddenSelect.value = variantId;
            hiddenSelect.dispatchEvent(new Event('change'));
          }
        }
      });
    });
  };
  
  // Initialize all modules
  initCountdown();
  initStickyBar();
  initFAQ();
  initSmoothScroll();
  initScrollReveal();
  initVariantSelector();

});
